<template>
  <div @blur="open = false" class="custom-select" :class="{ 'custom-select--nav': navLike }" :tabindex="tabindex">
    <div
      @click="open = !open"
      :class="navLike ? ['header-nav-link', { 'header-nav-link--active': open }] : selectedClass"
    >
      <div
        class="flex items-center gap-1 bg-[initial] xl:p-0 justify-center rounded-[5px]"
        :class="
          navLike
            ? ''
            : {
                'flex-row-reverse': isForHeader,
                'p-4 w-[32px] h-[32px] md:w-[44px] md:h-[44px] xl:w-auto xl:h-auto': true,
              }
        "
      >
        <icon-atlas
          v-if="!navLike"
          class="w-[24px] h-[24px] xl:block hidden"
          :class="{
            'text-[21px] md:text-[31px]': !isForHeader,
            'md:w-[32px] md:h-[32px]': theme === 'kids',
          }"
        />
        <span v-if="$i18n.locale !== 'kk'" class="block">{{ formatLocale($i18n.locale).toUpperCase() }}</span>
        <span v-else class="block">KZ</span>
      </div>
    </div>
    <div class="items-wrapper z-50" :class="{ selectHide: !open, [listPosition]: true }">
      <div class="items">
        <div
          v-for="locale of locales"
          v-show="!!locale.language"
          :key="locale.code"
          @click="
            () => {
              setLocale(locale.code)
              $emit('input', locale.code)
            }
          "
          class="flex justify-between items-center"
        >
          <span>
            {{ locale.language }}
          </span>
          <figure class="xl:w-[24px] xl:h-[24px] md:w-[22px] md:h-[22px] w-[20px] h-[20px]">
            <img loading="lazy" :src="`/img/flags/${locale.code}.png`" />
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { theme } from "@/services/getSiteTheme"
import { findLanguage, rememberLocale } from "@/services/localizationHelper"
import { capitalizeFirstLetter } from "@/services/text-formating"

// eslint-disable-next-line no-restricted-syntax
export default {
  name: "LocalesSwitcher",
  props: {
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    isForHeader: {
      type: Boolean,
      default: false,
    },
    listPosition: {
      type: String,
      default: "right",
    },
    navLike: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input"],
  data() {
    return {
      open: false,
      theme,
    }
  },

  computed: {
    locales() {
      return this.$i18n.availableLocales.map((l) => ({ code: l, language: findLanguage(l) }))
    },
    selectedClass() {
      return [
        "selected text-black hover:text-secondary-hover",
        {
          "open text-secondary-pressed": this.open,
        },
      ]
    },
  },

  mounted() {
    this.$emit("input", this.selected)
  },

  methods: {
    formatLocale(locale) {
      return capitalizeFirstLetter(locale)
    },
    setLocale(locale) {
      this.$i18n.locale = locale
      rememberLocale(locale)
      this.open = false
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-select {
  position: relative;
  text-align: right;
  outline: none;
  line-height: 47px;
}

.custom-select--nav {
  line-height: 32px;
  text-align: center;
}

.custom-select .selected {
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  @apply text-xl font-medium;
}

/* .custom-select .selected.open {
    } */

.custom-select .selected:after {
  display: none;
  position: absolute;
  content: "";
  top: 32px;
  right: 27px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10.5px 23px 10.5px;
  border-color: transparent transparent #333 transparent;
}

.custom-select .items-wrapper {
  @apply absolute top-[35px]  z-50 w-[216px] h-48 p-4 border-[2px] border-spacing-1 border-secondary rounded-[0.625rem]
        bg-white;

  &.right {
    @apply xl:left-0 xl:right-0 -left-40;
  }

  &.left {
    @apply xl:-left-40 -left-48 right-0;
  }
}

.custom-select .items {
  @apply text-left h-full overflow-auto pr-4;
}

.custom-select .items div {
  @apply text-dark text-base py-2 cursor-pointer hover:text-secondary-hover active:text-secondary-pressed;
  user-select: none;
}

.selectHide {
  display: none;
}

::-webkit-scrollbar {
  @apply w-1 cursor-pointer;
}

::-webkit-scrollbar-track {
  @apply bg-gray-light;
}

::-webkit-scrollbar-thumb {
  @apply bg-secondary rounded-[0.625rem] hover:bg-secondary-hover;
}
</style>
